import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Card, CardContent, CardActions, Button, Typography} from 'views/components';
import {ThumbUpOffAltOutlined, ThumbDownOffAltOutlined} from 'views/icons';
import {Translate} from 'views/module';

import backend from 'utils/backend';

const WasHelpfulCard = (props) => {
  const {clientRn, user, statusProgressWrap: progressWrap, articleTitle, articleRN} = props;
  const [isHelpful, setIsHelpful] = React.useState(null);

  const handleIsHelpful = React.useCallback(() => {
    setIsHelpful(true);
    progressWrap(async () => {
      const body = {
        clientRelationshipRn: user.userRn,
        articleTitle,
        feedback: {
          isHelpful: true,
        },
      };
      await backend.clientSupport.createArticleFeedback(clientRn, articleRN, body);
    });
  }, [clientRn, progressWrap, user, articleTitle, articleRN]);

  const handleIsNotHelpful = React.useCallback(() => {
    setIsHelpful(false);
    progressWrap(async () => {
      const body = {
        clientRelationshipRn: user.userRn,
        articleTitle,
        feedback: {
          isHelpful: false,
        },
      };
      await backend.clientSupport.createArticleFeedback(clientRn, articleRN, body);
    });
  }, [clientRn, progressWrap, user, articleTitle, articleRN]);

  return (
    <Card>
      <CardContent
        sx={{
          'display': 'flex',
          'alignItems': 'center',
          'justifyContent': 'space-between',
          '&:last-child': {
            pb: '16px',
          },
        }}
      >
        <Typography sx={{fontWeight: 500, fontSize: '16px', color: '#2D2925', lineHeight: '150%'}}>
          <Translate expression={'washelpful.wasHelpful'}/>
        </Typography>
        <CardActions sx={{m: 0, p: 0, gap: '8px', flexShrink: 0}}>
          <Button
            variant={isHelpful ? 'contained' : 'outlined'}
            onClick={handleIsHelpful}
            disableElevation
            disableRipple
          >
            <ThumbUpOffAltOutlined sx={{mr: 1}}/>
            <Translate expression={'washelpful.yes'}/>
          </Button>
          <Button
            variant={isHelpful === false ? 'contained' : 'outlined'}
            onClick={handleIsNotHelpful}
            disableElevation
            disableRipple
          >
            <ThumbDownOffAltOutlined sx={{mr: 1}}/>
            <Translate expression={'washelpful.no'}/>
          </Button>
        </CardActions>
      </CardContent>
    </Card>
  );
};

WasHelpfulCard.propTypes = {
  clientRn: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
  articleTitle: PropTypes.string.isRequired,
  articleRN: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  clientRn: state.user.clientRn,
  user: state.user,
});

export default connect(mapStateToProps, dispatch)(React.memo(WasHelpfulCard));
